<div class="notifications-container">
  @for (notification of notifications; track notification; let index = $index) {
    <div
      class="notification"
      [@fadeInUp]>
      <div class="notification-badge"
        [class.success]="notification.type === NotificationType.SUCCESS"
        [class.danger]="notification.type === NotificationType.DANGER"
        [class.warning]="notification.type === NotificationType.WARNING"
        [class.info]="notification.type === NotificationType.INFO">
        <mat-icon>
          @switch (notification.type) {
            @case (NotificationType.SUCCESS) {
              <mat-icon>check_circle</mat-icon>
            }
            @case (NotificationType.INFO) {
              <mat-icon>info</mat-icon>
            }
            @case (NotificationType.WARNING) {
              <mat-icon>warning</mat-icon>
            }
            @case (NotificationType.DANGER) {
              <mat-icon>cancel</mat-icon>
            }
          }
        </mat-icon>
      </div>
      <div class="notification-body">
        <div class="notification-content">
          @switch (notification.type) {
            @case (NotificationType.SUCCESS) {
              <strong>Success: </strong>
            }
            @case (NotificationType.INFO) {
              <strong>Info: </strong>
            }
            @case (NotificationType.WARNING) {
              <strong>Warning: </strong>
            }
            @case (NotificationType.DANGER) {
              <strong>Failure: </strong>
            }
          }
          @if (!notification.component) {
            <span [innerHtml]="notification.text"></span>
          }
          @if (notification.component) {
            <ng-container *ngComponentOutlet="notification.component; injector: getComponentInjector(notification);"></ng-container>
          }
        </div>
        <button ngfButton mode="icon" size="small" (click)="dismiss(index)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  }
</div>
